# groupon-deal-timer
require('../../groupon-deal-timer/frontend/urgency.js')

window.UrgencyTimer ?= {}
window.UrgencyTimer.current ?= {}

UrgencyTimer.Model = require './models/countdown_timer'
UrgencyTimer.View = require './views/countdown_timer'

UrgencyTimer.init = ({umsData}, done = ->) ->
  endAt = umsData?.urgencyTimer?.endAt
  return done() unless endAt

  timerModel = new UrgencyTimer.Model
    endAt: endAt

  window.UrgencyTimer.current.timerModel = timerModel

  window.UrgencyTimer.current.timerView  = new UrgencyTimer.View
    model: timerModel
    i18n: I18n.scoped()
    el: umsData?.el

  window.UrgencyTimer.current.timerView.render()
  done()

module.exports = UrgencyTimer
